import { Helpers } from '../../helpers';
import { IExploreDevelop } from '../../interfaces/iexplore-develop';
import { Project } from '../project';

export class ExploreDevelopBase {
  ExploreDevelopId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Projects_ExploreDevelop?: Array<Project> | null;

  constructor(item?: IExploreDevelop) {
    if (item) {

      this.ExploreDevelopId = item.ExploreDevelopId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Projects_ExploreDevelop = Helpers.createClassArray(Project, item.Projects_ExploreDevelop);
    }
  }
}